















import { Component, Vue, Ref, Prop } from "vue-property-decorator";
const columns = [
  {
    title: 'page_plan_maintenance_spare_parts',
    dataIndex: 'materialName',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'page_plan_maintenance_number',
    dataIndex: 'number',
    ellipsis: true,
    width: 150,
  }
]

export default Vue.extend({
  data(){
    return {
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    dataSource:{
      type: Array,
      default: () => ([])
    },
  },
  methods:{
    close(){
      this.$emit('close')
    },
  }
})

